<template>
  <div class="card w-full">
    <transition name="modal">
      <address-modal
        v-if="showAddressModal"
        @close="showAddressModal = false"
        @addressAdded="
          showAddressModal = false;
          $emit('updateAddresses');
        "
      ></address-modal>
    </transition>

    <card-header :title="'Orden #' + order.id">
      <template #badge>
        <status-badge :status="order.status" />
      </template>
    </card-header>

    <p class="text-xs text-content-400">
      Última actualización: {{ formatDatetime(order.updated_at) }}
    </p>
<!-- 
    <div v-if="order.status === 'failed_to_send'" class="mt-2">
      <p class="font-medium text-sm text-error-500">
        Selecciona un nuevo método de entrega
      </p>

      <div class="flex space-x-2">
        <button class="secondary-button" @click.prevent="$emit('pickup')">
          Recoger en sucursal
        </button>
        <button class="secondary-button" @click.prevent="$emit('delivery')">
          Enviar nuevamente
        </button>
      </div>
    </div> -->

    <div class="detail-grid mt-2">
      <detail-field label="Cliente">
        <router-link
          :to="{
            name: 'clientsDetail',
            params: { id: order.client.id },
          }"
          class="underline system-button"
          >{{ order.client.name }} {{ order.client.last_name }}</router-link
        >
      </detail-field>

      <detail-field v-if="order.diet && order.diet.pet" label="Mascota">
        <router-link
          :to="{
            name: 'petsDetail',
            params: { id: order.diet.pet.id },
          }"
          class="underline system-button"
          >{{ order.diet.pet.name }}</router-link
        >
      </detail-field>

      <detail-field
        label="Fecha de entrega programada"
        :value="formatDate(order.min_delivery_date)"
      />

      <detail-field
        v-if="order.delivery_date"
        label="Fecha de entrega realizada"
        :value="formatDatetime(order.delivery_date)"
      />

      <detail-field label="Semanas" :value="order.weeks" />

      <detail-field label="Método de entrega" :value="order.pickup_delivery ? 'Pick-Up' : 'Envío'" />
      <!-- <div v-if="['pending', 'in_process'].includes(order.status)">
        <button
          v-if="!order.pickup_delivery"
          class="secondary-button mt-2"
          @click.prevent="$emit('pickup')"
        >
          Recoger en Sucursal
        </button>
        <button
          v-else-if="!changeToSendDelivery"
          class="secondary-button mt-2"
          @click.prevent="changeToSendDelivery = true"
        >
          Cambiar a Envío a Domicilio
        </button>
      </div> -->
    </div>

    <button
      v-if="changeToSendDelivery"
      class="delete-button mt-2"
      @click.prevent="
        changeToSendDelivery = false;
        newAddressId = null;
      "
    >
      Cancelar
    </button>

    <!-- <div v-if="changeToSendDelivery" class="w-full mt-2">
      <label for="delivery_address">Dirección de entrega</label>

      <custom-select
        class=""
        id="delivery_address"
        v-model="newAddressId"
        :options="getDeliveryAddressOptions()"
      />

      <button
        class="link text-sm font-base"
        @click.prevent="showAddressModal = true"
      >
        Agregar otra
      </button>

      <primary-button
        v-if="newAddressId"
        class="w-24 mx-0 mt-6"
        @buttonClicked="$emit('send', newAddressId)"
        >Confirmar</primary-button
      >
    </div> -->

    <div v-if="order.address && !order.pickup_delivery" class="mt-2 text-sm">
      <p class="detail-label">Dirección</p>
      <address-component
        :address="order.address"
        :showShippingPrice="
          ['pending', 'in_process', 'ready_for_delivery'].includes(order.status)
        "
        :branchId="order.branch_id"
      />
    </div>

    <branch-component class="mt-2" :branch="order.branch" />

    <detail-field v-if="order.shipping_price" label="Costo de envío" :value="integerToCurrency(order.shipping_price)" />

    <div v-if="!order.pickup_delivery && ['delivered'].includes(order.status)">
      <section-header title="Datos de envío" />

      <div class="card-bordered">
        <div class="detail-grid">
          <detail-field label="Paquetería" :value="order.carrier ?? '-'" />

          <detail-field label="URL de rastreo">
            <a
              v-if="order.tracking_number"
              class="link underline text-sm text-content-400"
              :href="getTermsUrl()"
              target="_blank"
              >{{ order.tracking_number ?? "-" }}</a
            >
            <p v-else class="detail-value">-</p>
          </detail-field>
        </div>
      </div>
    </div>

    <div
      class="mt-2 text-sm"
      v-if="
        !order.pickup_delivery &&
        order.related_shipment_orders &&
        order.related_shipment_orders.length > 0
      "
    >
      <p class="font-medium">
        Esta orden debe enviarse con las siguientes órdenes:
      </p>
      <div class="flex space-x-2">
        <p
          v-for="relatedOrder in order.related_shipment_orders"
          :key="relatedOrder.id"
          class="text-sm text-content-400"
        >
          #{{ relatedOrder.id }}
        </p>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import OptionsMenu from "../ui/OptionsMenu";
import AddressComponent from "../ui/Address";
import BranchComponent from "../ui/Branch";
import AddressModal from "../modals/AddressModal";
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "General",

  components: {
    OptionsMenu,
    AddressComponent,
    BranchComponent,
    AddressModal,
  },

  data() {
    return {
      changeToSendDelivery: false,
      newAddressId: null,
      showAddressModal: false,
    };
  },

  props: {
    order: Object,
  },

  methods: {
    formatDate,

    formatDatetime,

    integerToCurrency,

    getOptions(order) {
      if (order.status === "failed_to_send") {
        return [
          { action: "pickupDelivery", label: "Recoger en sucursal" },
          { action: "delivery", label: "Enviar nuevamente" },
        ];
      }
    },

    getStatus(status) {
      switch (status) {
        case "pending":
          return "Pendiente";
        case "in_process":
          return "En Proceso";
        case "ready_for_pickup":
          return "Lista para Pick-Up";
        case "ready_for_delivery":
          return "Lista para Enviar";
        case "delivered":
          return "Entregada / Enviada";
        case "failed_to_send":
          return "Fallida al Enviar";
        default:
          return "";
      }
    },

    getDeliveryAddressOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.order.branch.addresses.forEach((address) => {
        if (address.pivot.valid_for_shipping) {
          options.push({
            value: address.id,
            label: `${address.street} #${address.exterior_number}${
              address.shipping_price
                ? " - " +
                  this.integerToCurrency(address.shipping_price) +
                  " por envío"
                : ""
            }`,
          });
        }
      });

      return options;
    },
  },
};
</script>